module.exports = __webpack_public_path__ + "img/Jump Casting12.b45239b3.jpg";